import React, { useEffect, useState } from "react";
import { Button, Modal, Upload, message } from "antd";
import type { RcFile, UploadProps } from "antd/es/upload";
import type { UploadFile } from "antd/es/upload/interface";
import { uploadImgSVG } from "../../../assets/SVGs/SVGs";

import { HiUpload } from "react-icons/hi";
import IMGUploader from "../../common/ui/IMGUploader";
const getBase64 = (file: RcFile): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = (error) => reject(error);
  });
type UploadImagProps = {
  imgs: Array<UploadFile | null>;
  setImgs: React.Dispatch<React.SetStateAction<Array<UploadFile | null>>>;
  index: number;
};
const SalonGalleryImg: React.FC<UploadImagProps> = ({
  imgs,
  setImgs,
  index,
}) => {
  const [fileList, setFileList] = useState<UploadFile[]>(() =>
    (imgs[index] as UploadFile) ? [imgs[index] as UploadFile] : []
  );

  return (
    <IMGUploader
      name={"image-" + index}
      listType="picture"
      fileList={fileList}
      setFileList={setFileList}
      imgValidation
      additionalOnChange={(newFileList) => {
        let newImgs = [...imgs];
        newImgs[index] = newFileList[0] ? newFileList[0] : null;
        setFileList(newFileList);
        setImgs(newImgs);
      }}
    />
  );
};

export default SalonGalleryImg;
